import { useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import { usePlatformStore } from '@/stores/platformStore'

export function useAuth() {
  const { session, isAuthLoading, setSession, setAuthLoading } = usePlatformStore()

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setAuthLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === 'SIGNED_IN' && session?.provider_token) {
          localStorage.setItem('exmarked_gh_token', session.provider_token)
        }
        if (event === 'SIGNED_OUT') {
          localStorage.removeItem('exmarked_gh_token')
        }
        setSession(session)
        setAuthLoading(false)
      }
    )

    return () => subscription.unsubscribe()
  }, [setSession, setAuthLoading])

  const signInWithGitHub = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'github',
      options: {
        redirectTo: window.location.origin,
        scopes: 'repo read:user',
      },
    })
  }

  const signOut = async () => {
    await supabase.auth.signOut()
  }

  return { session, isAuthLoading, signInWithGitHub, signOut }
}
